import styled from 'styled-components'

const AffiliateBadgeUi = styled.div`
  width: 165px;
  height: 38px;
  background-size: cover;
  padding: 3px 0;
  position: fixed;
  bottom: 4px;
  right: 4px;
  z-index: 3;
`

export default AffiliateBadgeUi
